module.exports = __webpack_public_path__ + "static/GorditaRegular-7313374a4da07a7cfa920baff8dacdfa.woff";